import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Heading, Box, Spinner, Flex } from '@chakra-ui/react';
import ArticleForm from './ArticleForm';
import axios from '../../axiosConfig';

const ArticleEdit = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const res = await axios.get(`/admin/articles/${id}`);
        setArticle(res.data);
      } catch (err) {
        console.error('Failed to load article', err);
      }
    };
    fetchArticle();
  }, [id]);

  const handleSubmit = async (formData) => {
    setSubmitting(true);
    try {
      await axios.put(`/admin/articles/${id}`, formData);
      navigate('/app/articles');
    } catch (err) {
      console.error('Failed to update article', err);
    } finally {
      setSubmitting(false);
    }
  };

  if (!article) {
    return (
      <Flex justify="center" align="center" height="50vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <Box>
      <Heading size="lg" mb={6}>
        Edit Article
      </Heading>
      <ArticleForm initialData={article} onSubmit={handleSubmit} isSubmitting={submitting} />
    </Box>
  );
};

export default ArticleEdit;